import { z } from 'zod';


/**
 * Schema para crear área
 */
const createAreaBaseSchema = z.object({
  code: z
    .string()
    .min(1, 'organization:validation.codeRequired')
    .max(30, 'organization:validation.codeMaxLength')
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      'organization:validation.codeInvalidFormat',
    ),

  name: z
    .string()
    .min(1, 'organization:validation.nameRequired')
    .max(100, 'organization:validation.nameMaxLength'),

  parentAreaId: z.union([
    z.coerce
      .number({
        invalid_type_error: 'organization:validation.parentAreaInvalid',
      })
      .int('organization:validation.parentAreaInvalid')
      .positive('organization:validation.parentAreaInvalid'),
    z.null(),
  ]),
});

export const createAreaSchema = createAreaBaseSchema.refine(
  (data) => data.parentAreaId !== null,
  {
    message: 'organization:validation.parentAreaRequired',
    path: ['parentAreaId'],
  },
);

/**
 * Tipo inferido del schema de crear área
 */
export type CreateAreaFormData = z.infer<typeof createAreaSchema>;
